import React from 'react';
import ContentLoader from 'react-content-loader';
const MyLoader = ({ width, height }) => (
  <ContentLoader
    speed={2}
    width={width}
    height={height - 6}
    viewBox={`0 0 ${width} ${height - 6}`}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb">
    <rect x="3" y="3" rx="3" ry="3" width={width} height={height} />
  </ContentLoader>
);

const corpUrl = (url = '') => {
  return url
    ? url.indexOf('legacy-pics.meiqiausercontent.com') > -1
      ? url.split('?').length === 2
        ? url.split('?')[0] + '?x-oss-process=style/small&' + url.split('?')[1]
        : url
      : url
    : '';
};

const isAliUrl = url => url && url.indexOf('legacy-pics.meiqiausercontent.com') > -1;

export { corpUrl, isAliUrl };

export default MyLoader;
